import React from "react";
import { Phone } from "lucide-react";
import { BRAND } from "../lib/api";

/**
 * Floating "Call Support" FAB. Designed to sit alongside the WhatsApp FAB on mobile.
 * Triggers tel: dial command immediately on tap.
 */
export const CallButton = ({ testid = "call-btn" }) => {
  return (
    <a
      href={`tel:${BRAND.phone_e164}`}
      data-testid={testid}
      aria-label={`Call ${BRAND.phone}`}
      className="fixed bottom-24 right-6 z-50 flex items-center gap-2 bg-[#D4AF37] hover:bg-[#E8C857] text-[#0F1D14] rounded-full shadow-2xl px-4 py-3 transition-all hover:scale-105"
      style={{ boxShadow: "0 10px 28px rgba(212,175,55,0.4)" }}
    >
      <Phone size={18} strokeWidth={2.5} />
      <span className="hidden sm:inline text-sm font-medium tracking-wide">Call Support</span>
    </a>
  );
};

export default CallButton;
